import Vue from 'vue'

import uiTreeElement from './src/ui-tree-element.vue';
import uiTree from './src/ui-tree.vue';

var components = [
  uiTreeElement,
  uiTree
]

components.forEach(function(component) {
  Vue.component(component.extendOptions.name, component);
})

export default components;



//////////////////
// WEBPACK FOOTER
// ./~/ui-tree/index.js
// module id = 567
// module chunks = 0